import { useState } from 'react';
import dynamic from 'next/dynamic';
import { capitalize } from 'lodash-es';

import PlayIcon from '@/icons/light/play.svg';
import { Button, ModalGallery } from '@/atoms';
import { ButtonSize, ButtonVariant } from '@/atoms/button/types';

import { gtmPush } from '@/utils';

import type { FunctionComponent } from 'react';
import type { TypeModalVideoProps } from './types';

const ReactPlayer = dynamic(() => import('react-player'), {
  ssr: false,
});

export const ModalVideo: FunctionComponent<TypeModalVideoProps> = ({
  src,
  flat,
  type,
}: TypeModalVideoProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {type === 'button' && (
        <Button
          variant={ButtonVariant.SECONDARY}
          size={ButtonSize.SMALL}
          className="max-w-max"
          onClick={() => {
            setIsOpen(true);
            gtmPush({
              event: 'explore_360_view',
              item_id: flat?.codigoUnidadAlquiler,
              item_name: flat?.nombreUE,
              item_type: capitalize(flat?.ventaAlquiler ?? ''),
            });
          }}
        >
          Ver video
        </Button>
      )}

      {type === 'link' && (
        <button
          className="flex items-center gap-2 text-primary-500"
          onClick={() => {
            setIsOpen(true);
            gtmPush({
              event: 'explore_360_view',
              item_id: flat?.codigoUnidadAlquiler,
              item_name: flat?.nombreUE,
              item_type: capitalize(flat?.ventaAlquiler ?? ''),
            });
          }}
        >
          Ver video
          <PlayIcon width={16} height={16} className="shrink-0" />
        </button>
      )}

      <ModalGallery
        closeModal={() => setIsOpen(false)}
        isOpen={isOpen}
        unmount
        className="lg:rounded-custom u-wrapper scrollbar-hide h-full overflow-y-auto bg-neutrals-0"
      >
        <ReactPlayer
          className="w-100 mb-4 h-screen md:min-h-[600px]"
          width="100%"
          height="600px"
          controls={true}
          playing={isOpen}
          onEnded={() => setIsOpen(false)}
          volume={0.8}
          url={src}
        />
      </ModalGallery>
    </>
  );
};

ModalVideo.displayName = 'ModalVideo';
